import PropTypes from "prop-types";

import {TERM_CHOICES} from "shared/constants/terms";
import {productPropType} from "apps/QuoterApp/validation/propTypes";

import ButtonInput from "shared/components/ButtonInput";
import Skeleton from "shared/components/Skeleton";
import PremiumDisplay from "shared/components/PremiumDisplay";

import 'apps/QuoterApp/pages/QuoteResultPage/ProductSummary/styles.scss';


function ProductSummary({item, onApply, onDetails}) {
    if (!item) {
        return <div className={'ProductSummary'}>
            <Skeleton className={"ProductSummary__Title"}/>
            <Skeleton className={"ProductSummary__Term"}/>

            <div className={"ProductSummary__Data"}>
                <Skeleton className={"ProductSummary__Data__CompanyLogo"}/>
                <PremiumDisplay className={"ProductSummary__Data__Premium"}/>
            </div>

            <div className={"ProductSummary__Data"}>
                <Skeleton className={"ProductSummary__Data__Button"}/>
                <Skeleton className={"ProductSummary__Data__Button"}/>
            </div>
        </div>;
    }

    const {image, name, company, term, premium} = item;

    return <div className={'ProductSummary'}>
        <div className={"ProductSummary__Title"}>{name}</div>
        <div className={"ProductSummary__Term"}>{TERM_CHOICES[term]}</div>

        <div className={"ProductSummary__Data"}>
            <div className={"ProductSummary__Data__CompanyLogo"}>
                <img src={image} alt={company}/>
            </div>
            <PremiumDisplay className={"ProductSummary__Data__Premium"} premium={premium}/>
        </div>
        <div className={"ProductSummary__Data"}>
            <ButtonInput className={"ProductSummary__Data__Button"} outline={true} onClick={() => onDetails(item)}>
                Details
            </ButtonInput>
            <ButtonInput className={"ProductSummary__Data__Button"} onClick={() => onApply(item)}>Apply</ButtonInput>
        </div>
    </div>;
}

ProductSummary.propTypes = {
    item: productPropType,
    onApply: PropTypes.func.isRequired,
    onDetails: PropTypes.func.isRequired,
};

export default ProductSummary;
